import * as React from 'react';
import { Modal } from 'components';
import renderIcon from 'helpers/renderIcon';
import { thumbUrl } from 'helpers/common';
require('./style.scss');

export interface IStaffMember {
	name?: string;
	jobTitle?: string;
	description?: string;
	picture?: string;
}

interface IProps {
	closeModal?: () => Promise<any>;

	initialValues: IStaffMember;
}

class StaffMemberOverviewModal extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.closeModal = this.closeModal.bind(this);
	}

	public componentDidMount() {}

	private closeModal() {
		this.props?.closeModal();
	}

	public render() {
		const hasPicture = this.props.initialValues.picture;
		const picture = hasPicture ? (
			<div className="staff-member-image-container">
				<img
					src={thumbUrl(this.props.initialValues.picture)}
					alt={`${this.props.initialValues.name}'s profile picture`}
				/>
			</div>
		) : (
			<div className="staff-member-svg-container d-flex justify-content-center align-items-center">
				{renderIcon('smile_happy')}
			</div>
		);

		return (
			<div className="modal-wrapper" onClick={this.closeModal}>
				<Modal
					modalClass="modal-staff-member-overview"
					showHeaderCloseButton={true}
					closeModal={this.closeModal}
					size={'extraSmall'}
				>
					<div
						className="staff-member-overview-wrapper d-flex flex-column justify-content-center"
						onClick={(e) => e.stopPropagation()}
					>
						{picture}
						<div className="staff-member-details">
							<h4 className="staff-member-name">{this.props.initialValues.name}</h4>
							<p className="staff-member-title">
								{this.props.initialValues.jobTitle !== null ? this.props.initialValues.jobTitle : 'No job title'}
							</p>
							<p className="staff-member-description">
								{this.props.initialValues.description !== null
									? this.props.initialValues.description
									: 'User has not set a description'}
							</p>
						</div>
					</div>
				</Modal>
			</div>
		);
	}
}

export { StaffMemberOverviewModal };
